import { MessageSquare, History, Settings, Zap } from 'lucide-react';
import { useStore } from '../store';

export function Sidebar({ onClose }: { onClose?: () => void } = {}) {
  const { activePanel, setActivePanel, usage } = useStore();
  
  const handleNavClick = (id: string) => {
    setActivePanel(id as any);
    onClose?.();
  };
  
  const navItems = [
    { id: 'chat', icon: MessageSquare, label: '聊天' },
    { id: 'history', icon: History, label: '历史' },
    { id: 'settings', icon: Settings, label: '设置' },
  ];
  
  return (
    <aside className="w-64 h-full bg-surface-1 border-r border-border flex flex-col">
      {/* Logo */}
      <div className="p-6 flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand-gradient flex items-center justify-center shadow-[var(--shadow-brand)]">
          <span className="text-xl">🐾</span>
        </div>
        <div>
          <h1 className="text-base font-semibold text-text-primary">VidClaw</h1>
          <p className="text-xs text-text-muted">说人话，出视频</p>
        </div>
      </div>
      
      {/* Navigation */}
      <nav className="flex-1 px-3 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activePanel === item.id;
          return (
            <button
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className={`
                w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-150
                ${isActive
                  ? 'bg-brand/15 text-brand border border-brand/20'
                  : 'text-text-secondary hover:bg-surface-2 hover:text-text-primary'
                }
              `}
            >
              <Icon size={18} />
              <span className="text-sm font-medium">{item.label}</span>
            </button>
          );
        })}
      </nav>
      
      {/* Credits */}
      <div className="p-4 border-t border-border-subtle">
        <div className="bg-surface-2 rounded-xl px-4 py-3 border border-border-subtle">
          <div className="flex items-center gap-2 mb-1">
            <Zap size={14} className="text-accent" />
            <span className="text-xs text-text-muted">可用积分</span>
          </div>
          <p className="text-lg font-semibold text-text-primary font-mono">
            {usage.credits}
          </p>
        </div>
      </div>
      
      {/* Responsive: Mobile collapse hint */}
      <div className="hidden lg:block text-center py-2 text-[10px] text-text-disabled">
        网页版 v1.0
      </div>
    </aside>
  );
}